import React from "react";

const PageWrapperForm = ({
  config,
  children,
  handleOnclick,
  buttonTitle,
  buttonIcon,
  secondaryButtonTitle,
  secondaryButtonIcon,
  handleSecondaryOnclick,
}) => {
  const getPrimaryIcon = () => {
    if (buttonIcon) return buttonIcon;
    if (buttonTitle && (buttonTitle.includes("+") || buttonTitle.toLowerCase().includes("add") || buttonTitle.toLowerCase().includes("create"))) {
      return "iconoir-plus-circle";
    }
    return "iconoir-user";
  };

  const getSecondaryIcon = () => {
    if (secondaryButtonIcon) return secondaryButtonIcon;
    if (secondaryButtonTitle && (secondaryButtonTitle.includes("+") || secondaryButtonTitle.toLowerCase().includes("add") || secondaryButtonTitle.toLowerCase().includes("create"))) {
      return "iconoir-plus-circle";
    }
    return "iconoir-user";
  };

  return (
    <main>
      <div className="container-fluid">
        {/* Breadcrumb  */}
        <div className="row m-1">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <div>
              <h4 className="main-title">{config.title}</h4>
              <ul className="app-line-breadcrumbs mb-3">
                <li className="active">
                  <a className="f-s-14 f-w-500" href="#">
                    {config.title}
                  </a>
                </li>
              </ul>
            </div>

            {secondaryButtonTitle ? (
              <div
                style={{
                  gap: "1ch",
                  display: "flex",
                }}
              >
                {buttonTitle && (
                  <button
                    className="btn btn-light-primary"
                    onClick={handleOnclick}
                    type="button"
                    key={"primary-button"}
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <i className={`${getPrimaryIcon()} me-2`}></i>
                    {buttonTitle}
                  </button>
                )}
                <button
                  className="btn btn-light-primary"
                  onClick={handleSecondaryOnclick}
                  type="button"
                  key={"secondary-button"}
                  style={{ whiteSpace: "nowrap" }}
                >
                  <i className={`${getSecondaryIcon()} me-2`}></i>
                  {secondaryButtonTitle}
                </button>
              </div>
            ) : (
              <button
                className="btn btn-light-primary"
                onClick={handleOnclick}
                type="button"
                key={"primary-button"}
                style={{ whiteSpace: "nowrap" }}
              >
                <i className={`${getPrimaryIcon()} me-2`}></i>
                {buttonTitle}
              </button>
            )}
          </div>
        </div>

        {/* Table Section */}
        <div className="row advance-table-section">
          <div className="col-12">{children}</div>
        </div>
      </div>
    </main>
  );
};

export default PageWrapperForm;

// import React from 'react';

// const PageWrapper = ({ config, children }) => {
//   return (
//     <main>
//       <div className="container-fluid">
//         {/* Breadcrumb */}
//         <div className="row m-1">
//           <div className="col-12 d-flex justify-content-between align-items-center">
//             <div>
//               <h4 className="main-title">{config.title}</h4>
//               <ul className="app-line-breadcrumbs mb-3">
//                 <li>
//                   <a className="f-s-14 f-w-500" href="#">
//                     <span>
//                       <i className={`${config.breadcrumbIcon || 'ph-duotone ph-table'} f-s-16`}></i> {config.breadcrumbParent || 'Reports'}
//                     </span>
//                   </a>
//                 </li>
//                 <li className="active">
//                   <a className="f-s-14 f-w-500" href="#">{config.title}</a>
//                 </li>
//               </ul>
//             </div>

//             {config.showDateFilter && (
//               <button
//                 aria-controls="offcanvasTops"
//                 className="btn btn-light-primary"
//                 data-bs-target="#offcanvasTops"
//                 data-bs-toggle="offcanvas"
//                 type="button"
//               >
//                 <i className="iconoir-calendar me-2"></i>
//                 Filter
//               </button>
//             )}
//           </div>
//         </div>

//         {/* Table Section */}
//         <div className="row advance-table-section">
//           <div className="col-12">
//             {children}
//           </div>
//         </div>
//       </div>
//     </main>
//   );
// };

// export default PageWrapper;
